// modalWithBackground.jcss
import { addStyles } from 'ethcss'
import { IStyles, colors } from '../../theme'

const modalWithBackgroundStyles: IStyles = {
    wrapper: {
        position: 'fixed',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        background: 'rgba(0,0,0, 0.2)',
        zIndex: 2001,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'hidden',
        overscrollBehavior: 'none',
    },
    inner: {
        position: 'relative',
        width: '90%',
        maxWidth: '450px',
        padding: 20,
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
        borderRadius: 20,
        backgroundColor: colors.white,
    },
    title: {
        fontWeight: 700,
        fontSize: 18,
        textAlign: 'center',
        color: colors.black,
    },
    content: {
        marginBottom: 20,
    },
}

addStyles(modalWithBackgroundStyles)
export default modalWithBackgroundStyles
